export const SORT_OPTIONS = [
  {
    name: "Score",
    value: [],
  },
  {
    name: "Size ↓",
    value: [{ field: "size_ft_max", direction: "desc" }],
  },
  {
    name: "Size ↑",
    value: [{ field: "size_ft_max", direction: "asc" }],
  },
  {
    name: "Rent PA ↑",
    value: [{ field: "rent_pa", direction: "asc" }],
  },
  {
    name: "Rent PA ↓",
    value: [{ field: "rent_pa", direction: "desc" }],
  },
  {
    name: "Listed date ↓",
    value: [{ field: "listed", direction: "desc" }],
  },
  {
    name: "Distance ↑",
    value: [
      {
        _geo_distance: {
          location: [50, 0],
          order: "asc",
          unit: "km",
          mode: "min",
          distance_type: "arc",
          // "ignore_unmapped": true
        },
      },
    ],
  },
];
